export function existeCpf(privateClaims) {
  return privateClaims && privateClaims.cpf;
}

export function existeNome(privateClaims) {
  return privateClaims && privateClaims.nomeCompleto;
}

export function extraiCpf(privateClaims) {
  return privateClaims.cpf;
}

export function extraiNome(privateClaims) {
  return existeNome ? privateClaims.nomeCompleto : 'cidadão';
}

export function extraiCnpjDeGovBrCnpjs(govBrCnpjs) {
  return govBrCnpjs && govBrCnpjs.map ? govBrCnpjs.map(govBrCnpj => govBrCnpj.cnpj) : [];
}
